export const FLIGHTS_HEADER = "Flights";

export const ROUND_TRIP_TEXT = "Round Trip";

export const ONE_WAY_TEXT = "One Way";

export const UPDATE_CALENDAR_TEXT = "Updating your calendar";

export const CHOOSE_DATE = "Choose your dates";
